<template>
  <div class="col-12 col-lg-4 bground-config-clean vertical-align advertisements" :style="{ backgroundImage: `url('${urlImage}')` }">
    <div class="p-4">
      <h2 class="text-center text-light mb-16">{{title}}</h2>
      <p class="text-center text-light mb-24">{{contents}}</p>
      <button @click="redi" type="button" class="btn btn-outline-light font-weight-bold d-block mx-auto">{{buttonText}}</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CarCard',
  props: {
    buttonText: String,
    title: String,
    contents: String,
    urlImage: String,
    url: String
  },
  computed: {
    carImage () {
      return {
        backgroundImage: `url${require('' + this.urlImage + '')}`
      }
    }
  },
  methods: {
    redi () {
      window.location = this.url
    }
  },
  created () {
  }
}
</script>

<style scoped>

</style>
